import React from "react";
import {css} from "@panda/css";

import {BrandSearchIcon} from "@pg-design/icons-module";
import {IOption} from "@pg-design/select-module";
import {Text} from "@pg-design/text-module";
import {IInteractiveRegion} from "@pg-rp/interactive-regions-map";

import {useRegionDetails} from "../../../regions/hooks/use_region_details";
import {HomeMatchUserPreferencesRegionMap} from "./HomeMatchUserPreferencesRegionMap";

interface IProps {
    mapHeight?: number;
    selectedRegions?: IOption<number>[] | null;
    onUpdateRegions: (selectedRegions: IInteractiveRegion[], parentRegion: {id: number; name: string; slug: string} | null) => void;
}

export const HomeMatchUserPreferencesLocationPreview: React.FC<IProps> = (props) => {
    const {mapHeight, selectedRegions, onUpdateRegions} = props;

    const {selectedRegionsDetails, hasAnyRegionDetails, doesRegionsBelongToSameCity} = useRegionDetails({
        regionIds: selectedRegions?.map((region) => Number(region.value))
    });

    return (
        <div className={containerStyle}>
            <div className={mapHeight == null ? mapWrapperStyle : sizedMapWrapperStyle}>
                {doesRegionsBelongToSameCity ? (
                    <HomeMatchUserPreferencesRegionMap
                        handleUpdateRegions={onUpdateRegions}
                        mapHeight={mapHeight}
                        selectedRegions={selectedRegionsDetails}
                        showMainRegionMapOutline
                        updateRegionsImmediately
                    />
                ) : hasAnyRegionDetails ? (
                    <div className={noMapSelectionStyle}>
                        <div className={iconWrapperStyle}>
                            <BrandSearchIcon size="10" />
                        </div>
                        <Text variant="body_copy_1" className={messageTextStyle}>
                            Wybrane regiony nie mają opcji wyboru za pomocą mapy
                        </Text>
                    </div>
                ) : (
                    <div className={noMapSelectionStyle}>
                        <div className={iconWrapperStyle}>
                            <BrandSearchIcon size="10" />
                        </div>
                        <Text variant="body_copy_1" className={messageTextStyle}>
                            Wybierz przynajmniej jedną lokalizację, <br /> aby móc wybrać regiony za pomocą mapy
                        </Text>
                    </div>
                )}
            </div>
        </div>
    );
};

const containerStyle = css({
    width: "100%"
});

const mapWrapperStyle = css({
    width: "100%",
    isolation: "isolate",
    position: "relative",
    md: {
        height: "550px"
    }
});

const sizedMapWrapperStyle = css({
    isolation: "isolate",
    position: "relative",
    width: "100%"
});

const noMapSelectionStyle = css({
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    height: "100%",
    padding: 3,
    backgroundColor: "var(--colors-gray-50)"
});

const iconWrapperStyle = css({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "10rem",
    height: "10rem",
    color: "var(--colors-gray-400)",
    marginBottom: 4
});

const messageTextStyle = css({
    textAlign: "center",
    color: "var(--colors-gray-700)"
});
import React from "react";
import {css} from "@panda/css";

import {BrandSearchIcon} from "@pg-design/icons-module";
import {IOption} from "@pg-design/select-module";
import {Text} from "@pg-design/text-module";
import {IInteractiveRegion} from "@pg-rp/interactive-regions-map";

import {useRegionDetails} from "../../../regions/hooks/use_region_details";
import {HomeMatchUserPreferencesRegionMap} from "./HomeMatchUserPreferencesRegionMap";

interface IProps {
    mapHeight?: number;
    selectedRegions?: IOption<number>[] | null;
    onUpdateRegions: (selectedRegions: IInteractiveRegion[], parentRegion: {id: number; name: string; slug: string} | null) => void;
}

export const HomeMatchUserPreferencesLocationPreview: React.FC<IProps> = (props) => {
    const {mapHeight, selectedRegions, onUpdateRegions} = props;

    const {selectedRegionsDetails, hasAnyRegionDetails, doesRegionsBelongToSameCity} = useRegionDetails({
        regionIds: selectedRegions?.map((region) => Number(region.value))
    });

    return (
        <div className={containerStyle}>
            <div className={mapHeight == null ? mapWrapperStyle : sizedMapWrapperStyle}>
                {doesRegionsBelongToSameCity ? (
                    <HomeMatchUserPreferencesRegionMap
                        handleUpdateRegions={onUpdateRegions}
                        mapHeight={mapHeight}
                        selectedRegions={selectedRegionsDetails}
                        showMainRegionMapOutline
                        updateRegionsImmediately
                    />
                ) : hasAnyRegionDetails ? (
                    <div className={noMapSelectionStyle}>
                        <div className={iconWrapperStyle}>
                            <BrandSearchIcon size="10" />
                        </div>
                        <Text variant="body_copy_1" className={messageTextStyle}>
                            Wybrane regiony nie mają opcji wyboru za pomocą mapy
                        </Text>
                    </div>
                ) : (
                    <div className={noMapSelectionStyle}>
                        <div className={iconWrapperStyle}>
                            <BrandSearchIcon size="10" />
                        </div>
                        <Text variant="body_copy_1" className={messageTextStyle}>
                            Wybierz przynajmniej jedną lokalizację, <br /> aby móc wybrać regiony za pomocą mapy
                        </Text>
                    </div>
                )}
            </div>
        </div>
    );
};

const containerStyle = css({
    width: "100%"
});

const mapWrapperStyle = css({
    width: "100%",
    isolation: "isolate",
    position: "relative",
    md: {
        height: "550px"
    }
});

const sizedMapWrapperStyle = css({
    isolation: "isolate",
    position: "relative",
    width: "100%"
});

const noMapSelectionStyle = css({
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    height: "100%",
    padding: 3,
    backgroundColor: "var(--colors-gray-50)"
});

const iconWrapperStyle = css({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "10rem",
    height: "10rem",
    color: "var(--colors-gray-400)",
    marginBottom: 4
});

const messageTextStyle = css({
    textAlign: "center",
    color: "var(--colors-gray-700)"
});
